export default "__VITE_ASSET__D6VVOTLz__"